<script src="filter/form/home-assistance-list-dialog-filter-form.component.ts"></script>
<div *ngIf="demoModeActivated" style="width: 100%">
  <span style="font-size:1.2rem;text-align: center" class="c-white bg-warning d-block padding-v-xs"> {{'assistance.demo-mode-activated' | translate}} </span>
</div>
<div class="grid-y medium-grid-frame ng-untouched ng-pristine ng-invalid" id="assistances">

  <!-- HEADER -->
  <div appFoundation class="cell shrink header medium-cell-block-container">
    <div class="hds-panel overflow-visible">
      <div class="hds-panel-detail-header">
        <div class="hds-panel-detail-header-main-container split-main-container">
          <div class="hds-panel-detail-header-menu">
            <div class="hds-panel-detail-header-menu-list">
              <div class="hds-panel-detail-header-menu-list-item">
                <app-filter [source]="solutions" dataToggle="solution-select" label="Solution"></app-filter>
              </div>
              <div class="hds-panel-detail-header-menu-list-item">
                <app-filter [source]="categories" dataToggle="categories-select" label="Catégories"></app-filter>
              </div>
              <div class="hds-panel-detail-header-menu-list-item">
                <app-filter [source]="importance" dataToggle="category-select" label="Importance"></app-filter>
              </div>
            </div>
          </div>
          <div class="hds-panel-detail-header-menu">
            <div class="hds-panel-detail-header-menu-list">
              <div class="hds-panel-detail-header-menu-list-item">
                <button (click)="onRequestAssistance()" class="button primary hollow">
                  <i class="fa fa-plus"> </i>&nbsp; {{'assistance.ask-assistance' | translate}}
                </button>
              </div>
              <div class="hds-panel-detail-header-menu-list-item" *ngIf="isConsultantAndIsDemo">
                <button (click)="onCreateAssistance()" class="button primary hollow">
                  <i class="fa fa-plus"> </i>&nbsp; {{'assistance.add-assistance' | translate}}
                </button>
              </div>
            </div>
            <!-- dropdown open -->
            <div class="dropdown-pane z-depth-3 bottom" data-auto-focus="false" data-dropdown data-close-on-click="true" id="solution-select">
              <app-filter-selection (submitForm)="applyFilter()" *ngIf="solutions && solutions.length !== 0" [source]="solutions"
                                    dataToggle="solution-select" label="Solutions"></app-filter-selection>
            </div>
            <div class="dropdown-pane z-depth-3 bottom" data-auto-focus="false" data-dropdown data-close-on-click="true" id="categories-select">
              <app-filter-selection (submitForm)="applyFilter()" *ngIf="categories" [source]="categories" dataToggle="categories-select"
                                    label="Catégories"></app-filter-selection>
            </div>
            <div class="dropdown-pane z-depth-3 bottom" data-auto-focus="false" data-dropdown data-close-on-click="true" id="category-select">
              <app-filter-selection (submitForm)="applyFilter()" *ngIf="importance" [source]="importance" dataToggle="category-select"
                                    label="Importance"></app-filter-selection>
            </div>
          </div>
        </div>
        <div class="hds-panel-detail-header-side-menu separated">
          <div class="hds-panel-detail-header-menu">
            <div class="hds-panel-detail-header-menu-list">
              <div class="hds-panel-detail-header-menu-list-item" data-toggler="is-hidden" id="search-bar">
                <input [formControl]="research" style="width: 300px !important;display: inline-block" type="text">
                <button class="margin-l-s" (click)="onRemoveResearch()" *ngIf="research.value" style="cursor: pointer" type="button">
                  <i class="fa fa-close"></i>
                </button>
              </div>
              <div class="hds-panel-detail-header-menu-list-item i-block padding-l-s padding-t-s">
                <button aria-controls="search-bar" class="button primary hollow" data-toggle="search-bar"
                        style="border:0 none;">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <div class="hds-panel-detail-header-menu-list-item collapsed">
                <button aria-label="Close modal"
                        class="button hollow link default"
                        mat-dialog-close>
                  <i class="margin-all fal fa-times fa-2x"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- BODY -->
  <div class="cell medium-auto medium-cell-block-container">
    <div class="hds-panel">
      <div class="hds-panel-body bg-very-light-gray padding-reset" style="height: calc( 100vh - 65px);">
        <ng-container *ngIf="sortedData; else loader">
          <div class="layout-list-details" style="height: 100%">
            <div class="layout-container {{togglePanel ? 'active' : ''}}">
              <div class="layout-list-view" style="height: 100%">
                <div class="layout-view-content">
                  <div class="row expanded">
                    <div class="columns small-12">
                      <div class="margin-t">
                        <div class="top-bar-inverse bg-transparent padding-v-xs ">
                          <div class="top-bar-left">
                            <ul class="menu">
                              <li>
                                <div class="padding-h padding-v-xs">
                                  <h3 (click)="onToggleRead()" class="i-block" style="cursor: pointer;">
                                    <span *ngIf="toggleReadAssistances">{{'tickets' | translate}} &nbsp;</span>
                                    <small *ngIf="!toggleReadAssistances">{{'tickets' | translate}} &nbsp;</small>
                                  </h3>
                                  <span *ngIf="!listAssistances || sortedData.length === listAssistances.length"
                                        class="badge filter">{{sortedData.length}}</span>
                                  <span *ngIf="listAssistances && sortedData.length !== listAssistances.length"
                                        class="badge filter">{{sortedData.length}} / {{listAssistances.length}}</span>

                                  <h3 (click)="onToggleUnread()" class="i-block" style="cursor: pointer;">
                                    <span *ngIf="!toggleReadAssistances" class="i-block padding-l">{{'assistance.not-read' | translate}}
                                      &nbsp;</span>
                                    <small *ngIf="toggleReadAssistances" class="i-block padding-l">{{'assistance.not-read' | translate}}
                                      &nbsp;</small>
                                  </h3>
                                  <span class="badge warning">{{getUnreadAssistanceCount()}}</span>
                                </div>
                              </li>
                              <ng-content></ng-content>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <table (matSortChange)="onSortData($event)" *ngIf="sortedData.length > 0"
                             class="grid-list border-reset margin-b bg-white"
                             matSort matSortActive="date" matSortDirection="asc" matSortDisableClear>
                        <tr class="grid-list-row border-b">
                          <th id="status" class="grid-list-cell cell-status-assistance"
                              mat-sort-header="statut">{{'assistance.status'| translate}}</th>
                          <th id="status-label" class="grid-list-cell cell-status-label-assistance"></th>
                          <th id="solution" class="grid-list-cell cell-service-assistance"
                              mat-sort-header="solution">{{'assistance.solution'| translate}}</th>
                          <th id="date" class="grid-list-cell cell-date-assistance" mat-sort-header="date">
                            Date
                          </th>
                          <th id="category" class="grid-list-cell cell-category-assistance"
                              mat-sort-header="categorie">{{'assistance.category'| translate}}</th>
                          <th id="importance" class="grid-list-cell cell-importance-assistance"
                              mat-sort-header="importance">{{'assistance.importance'| translate}}</th>
                          <th id="label" class="grid-list-cell cell-label-assistance"
                              mat-sort-header="label">{{'assistance.label'| translate}}</th>
                          <th id="doc" class="grid-list-cell cell-icon-attached"
                              mat-sort-header="doc">{{'assistance.documents'| translate}}</th>
                          <th id="icon" class="grid-list-cell cell-icon-assistance"></th>
                        </tr>
                        <tr *ngFor="let assistance of sortedData" (click)="onToggleView(assistance?.id?.toString())"
                            class="grid-list-row hoverable item-to-toggle trigger-resize-on-click separated {{selectedAssistance?.id === assistance.id ? 'hover' : ''}}">
                          <td class="grid-list-cell cell-status-assistance">
                            <span class="fa-stack fa-lg margin-t-s margin-l-s">
                              <i class="fa fa-circle fa-stack-2x c-{{this.getColorForStatus(assistance.status)}}"></i>
                              <i class="fa fa-{{this.getIconForStatus(assistance.status)}} fa-stack-1x c-white"></i>
                            </span>
                          </td>
                          <td class="grid-list-cell cell-status-label-assistance">
                            <span
                              class="c-{{this.getColorForStatus(assistance.status)}}">{{assistance.status}}</span>
                          </td>
                          <td class="grid-list-cell cell-service-assistance c-insito">
                            {{assistance.solution | applicationName}}
                          </td>
                          <td class="grid-list-cell cell-date-assistance">
                            {{assistance.creationDate | date: 'dd/MM/yyyy'}}
                          </td>
                          <td class="grid-list-cell cell-category-assistance c-neutral">
                            {{assistance.category}}
                          </td>
                          <td class="grid-list-cell cell-importance-assistance c-info f-9">
                            <span class="i-block">
                              <span
                                *ngIf="assistance.importance === 'Haute' || assistance.importance === 'Moyenne' || assistance.importance === 'Faible'"
                                class="fa fa-circle"></span>
                              <span *ngIf="assistance.importance === 'Haute' || assistance.importance === 'Moyenne'"
                                    class="fa fa-circle"></span>
                              <span *ngIf="assistance.importance === 'Haute'" class="fa fa-circle"></span>
                            </span>
                          </td>
                          <td class="grid-list-cell cell-label-assistance ellipsis">
                            <span [ngStyle]="{'font-weight': assistance.read ? 'normal':'bold'}">
                              {{assistance.label}}
                            </span>
                          </td>
                          <td class="grid-list-cell cell-icon-attached">
                            <span *ngIf="assistance.documents !== null  && assistance.documents.length > 0" class="fa-stack fa-lg">
                              <i class="fa fa-paperclip fa-stack-1x c-primary"></i>
                            </span>
                          </td>
                          <td class="grid-list-cell cell-icon-assistance">
                            <span class="fa-stack fa-lg" style="width: 2em">
                              <i class="fa fa-square fa-stack-2x c-white"></i>
                              <i class="far fa-arrow-alt-circle-right fa-stack-1x c-primary"></i>
                            </span>
                          </td>
                        </tr>
                      </table>
                      <div *ngIf="listAssistances.length === 0" class="padding-v-l text-center">
                        <div class="padding-v">
                          <span class="fa fa-tags fa-lg margin-b-s"></span><br>

                        </div>
                      </div>
                      <div *ngIf="listAssistances.length > 0 && sortedData.length === 0" class="padding-v-l text-center">
                        <div class="padding-v">
                          <span class="fa fa-tags fa-lg margin-b-s"></span><br>
                          {{'assistance.no-assistance-to-display' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="selectedAssistance" class="layout-details-view bg-white" style="height:100%">
                <div class="layout-view-content bg-white" style="min-height:calc(100vh - 250px);">
                  <div class="padding-all pos-relative border-b">
                    <button (click)="onClosePanel()" class="close-button toggle-close">×</button>
                    <h3 class="margin-b-s">
                      <b>{{selectedAssistance.category}}</b>
                      <small><span class="fa fa-clock margin-l-s"></span> {{selectedAssistance.creationDate | date: 'dd/MM/yyyy'}}
                      </small>
                    </h3>
                    <h4 class="margin-b-s">{{selectedAssistance.label}}</h4>
                    <span class="label {{getColorForStatus(selectedAssistance.status)}}">
                      <span class="fa fa-{{getIconForStatus(selectedAssistance.status)}}">

                      </span> {{selectedAssistance.status}}
                    </span>
                    <span class="label insito margin-l">
                      {{selectedAssistance.solution.charAt(0).toUpperCase() + selectedAssistance.solution.slice(1)}}
                    </span>
                  </div>
                  <div *ngIf="isConsultantAndIsDemo" class="padding-all pos-relative border-b">
                    <button (click)="onEditAssistance(selectedAssistance)" class="xsmall button info margin-r-s">
                      <i class="fas fa-pencil margin-r-xs"></i>
                      {{'assistance.update-assistance' | translate}}
                    </button>
                    <button (click)="onDuplicateAssistance(selectedAssistance)" class="xsmall button dark-gray margin-r-s">
                      <i class="far fa-copy margin-r-xs"></i>
                      {{'assistance.duplicate-assistance' | translate}}
                    </button>
                    <button (click)="onDeleteAssistance(selectedAssistance)" class="xsmall button error">
                      <i class="far fa-trash-alt margin-r-xs"></i>
                      {{'assistance.delete-assistance' | translate}}
                    </button>
                  </div>
                  <div class="padding-all border-b bg-transparent bg-hover" style="display: flex">
                    <input *ngIf="isConsultantAndIsDemo" (change)="onCreateDocumentForAssistance($event, selectedAssistance)" id="file"
                           style="display: none"
                           type="file"/>
                    <label *ngIf="isConsultantAndIsDemo" class="button hollow info expanded" style="margin-right: 1.5rem" for="file">{{'assistance.add-documents' | translate}}</label>
                    <a class="button hollow info expanded" (click)="onSendMail(selectedAssistance)">{{'assistance.contact-consultant' | translate}}</a>
                  </div>
                  <div class="card border-reset padding-all">
                    <div *ngIf="selectedAssistance.documents && selectedAssistance.documents.length > 0" class="card-header card-padding bg-filter-light">
                      <div class="card-header-title">
                        <h4><i class="fa fa-file-text-o c-gray margin-r-s"></i>{{'assistance.documents' | translate}}</h4>
                      </div>
                    </div>

                    <ng-container *ngIf="!isCurrentlyUploadDocument; else loader">
                      <div *ngFor="let document of selectedAssistance.documents" class="padding-all border-b" style="background-color: #ecf2fb">
                        <div class="grid-x">
                          <div (click)="onOpenDocument(selectedAssistance.solution, document)" class="cell shrink margin-r-s cursor-hover">
                            <div class="thumbnail bg-white margin-reset">
                              <img src="assets/img/financeactive-logo.svg" style="width: 50px; height: 50px;" alt="">
                            </div>
                          </div>
                          <div (click)="onOpenDocument(selectedAssistance.solution, document)" class="cell auto cursor-hover">
                            <h5><strong>{{document.label}}</strong></h5>
                          </div>
                          <div class="cell shrink" *ngIf="isConsultantOrIsDemo">
                            <i class="far fa-trash-alt f-14 c-dark-gray cursor-hover" (click)="onDeleteDocumentForAssistance(selectedAssistance, document)"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>

                    <div class="card-body">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #loader>
          <div class="padding-v-l text-center"
               style="height: 200px; display: flex; align-items: center">
            <div class="widget-spinner">
              <div></div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
